import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { Router } from '@angular/router';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-my-vendors-widget',
  templateUrl: './my-vendors-widget.component.html',
  styleUrls: ['./my-vendors-widget.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class MyVendorsWidgetComponent implements OnInit {
  constructor(
    private router: Router,
    private ToastService: ToastService
  ) {}

  @Input() CompanyId!: number;

  navigateToVendorSearchPage() {
    this.router.navigate([
      'client',
      this.CompanyId,
      'vendors',
      'search',
      'client'
    ]);
  }

  ngOnInit(): void {
    if (!this.CompanyId) {
      throw this.ToastService.addErrorToast('Error', 'Missing Client Id.', {
        returnError: true
      });
    }
  }
}
